import * as Props from "../../types/PropTypes";
import { Content } from "@/types/PropTypes";
import ReactMarkdown from "react-markdown";
import styles from "./HistoryOfSudoku.module.scss";

export const ContentMarkup: React.FC<Content> = ({ content }) => (
  <div className={styles.contentWrapper}>
    <ReactMarkdown>{content}</ReactMarkdown>
  </div>
);
